export default __webpack_public_path__ + "static/media/self-excluded.02a235fc.svg";